import {useState} from "react";

import {SIGNED_OUT_RESERVATION_AUTH_STATE} from "../../reservation/constants/reservation_constants";
import {useReservationFlow} from "../../reservation/hooks/use_reservation_flow";
import {useStartReservationRegistration} from "../../reservation/hooks/use_start_reservation_registration";
import {getReservationTracker} from "../../reservation/tracking/get_reservation_tracker";
import {IReservationRequest} from "../../reservation/types/IReservationRequest";
import {IUseReservationFlowResult} from "../../reservation/types/IUseReservationFlow";
import {getReservationCloseHandlers} from "../../reservation/utils/get_reservation_close_handlers";
import {useAppSelector} from "../../store/hooks";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {AmplitudeAuthLocation} from "../tracking/track_amplitude_auth_event";
import {IUnlockChoiceData} from "../types/IUnlockChoiceData";
import {IUnlockChoiceReservationView} from "../types/IUnlockChoiceReservationView";

interface IUseUnlockChoiceReservationParams {
    data: IUnlockChoiceData | null;
    // the choice modal closes once - the reservation shares the request with the other ways out
    isCloseRequested: boolean;
    requestClose: () => void;
}

const getReservationRequest = (data: IUnlockChoiceData | null, propertyId: number | undefined, offerId: number | undefined): IReservationRequest | null =>
    data?.isReservationAvailable && propertyId && offerId
        ? {
              propertyId,
              offerId,
              vendorId: data.vendorId,
              propertyNumber: data.propertyNumber,
              vendorName: data.vendorName,
              offerType: data.offerType,
              placement: "unlock_choice"
          }
        : null;

const getReservationView = (
    flow: IUseReservationFlowResult,
    isConfirmed: boolean,
    onBack: () => void,
    onConfirmedClose: () => void
): IUnlockChoiceReservationView => ({
    step: isConfirmed ? "confirmed" : "code",
    codeStepProps: flow.codeStepProps,
    confirmedStepProps: flow.confirmedStepProps,
    isSubmitting: flow.isSubmitting,
    onBack,
    onConfirmedClose
});

// Handing over to the registration does not dismiss the choice, so it does not go through onClose; the user already has an account, so the login form opens
const useUnlockChoiceReservationFlow = (
    request: IReservationRequest | null,
    amplitudePlacement: AmplitudeAuthPlacement | null | undefined,
    amplitudeLocation: AmplitudeAuthLocation | undefined,
    isVisible: boolean
) => {
    const startReservationRegistration = useStartReservationRegistration();

    return useReservationFlow({
        request,
        authPlacement: amplitudePlacement,
        amplitudeLocation,
        // back on the cards the steps are hidden - showing them again reports their views anew
        isVisible,
        onUnauthenticated: (unauthenticatedRequest) =>
            startReservationRegistration(unauthenticatedRequest, SIGNED_OUT_RESERVATION_AUTH_STATE, {
                amplitudePlacement: amplitudePlacement ?? null,
                showLoginForm: true
            })
    });
};

// The free reservation of the offer choice - its steps replace the cards inside the same modal, and going back to the cards keeps the code already sent
export const useUnlockChoiceReservation = (params: IUseUnlockChoiceReservationParams) => {
    const {data, isCloseRequested, requestClose} = params;

    const {propertyId, offerId, amplitudePlacement, amplitudeLocation} = useAppSelector((state) => state.registrationFlow);
    const viewType = useAppSelector((state) => state.viewType.current);
    const [isVisible, setIsVisible] = useState(false);

    const request = getReservationRequest(data, propertyId, offerId);
    const flow = useUnlockChoiceReservationFlow(request, amplitudePlacement, amplitudeLocation, isVisible);

    const isConfirmed = isVisible && flow.state.status === "confirmed";
    const trackingContext = {authPlacement: amplitudePlacement ?? null, amplitudeLocation, viewType};
    const {close, confirmedClose} = getReservationCloseHandlers({
        request,
        isConfirmed,
        isSubmitting: flow.isSubmitting,
        isCloseRequested,
        trackingContext,
        requestClose
    });

    const start = () => {
        if (!request) {
            return;
        }

        // back from the code step the code already sent stays valid - the flow starts only once
        flow.start();
        setIsVisible(true);
    };

    const back = () => {
        if (flow.isSubmitting) {
            return;
        }

        if (request) {
            getReservationTracker(request).back(request, trackingContext);
        }

        setIsVisible(false);
    };

    return {
        isAvailable: request !== null,
        // the steps replace the cards
        isVisible,
        isConfirmed,
        view: isVisible ? getReservationView(flow, isConfirmed, back, confirmedClose) : null,
        start,
        // the close button, the overlay or Esc while the steps are shown - the reservation never leads to the price negotiation
        close,
        // call from the modal's onAfterClose
        reset: flow.reset
    };
};
import {useState} from "react";

import {SIGNED_OUT_RESERVATION_AUTH_STATE} from "../../reservation/constants/reservation_constants";
import {useReservationFlow} from "../../reservation/hooks/use_reservation_flow";
import {useStartReservationRegistration} from "../../reservation/hooks/use_start_reservation_registration";
import {getReservationTracker} from "../../reservation/tracking/get_reservation_tracker";
import {IReservationRequest} from "../../reservation/types/IReservationRequest";
import {IUseReservationFlowResult} from "../../reservation/types/IUseReservationFlow";
import {getReservationCloseHandlers} from "../../reservation/utils/get_reservation_close_handlers";
import {useAppSelector} from "../../store/hooks";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {AmplitudeAuthLocation} from "../tracking/track_amplitude_auth_event";
import {IUnlockChoiceData} from "../types/IUnlockChoiceData";
import {IUnlockChoiceReservationView} from "../types/IUnlockChoiceReservationView";

interface IUseUnlockChoiceReservationParams {
    data: IUnlockChoiceData | null;
    // the choice modal closes once - the reservation shares the request with the other ways out
    isCloseRequested: boolean;
    requestClose: () => void;
}

const getReservationRequest = (data: IUnlockChoiceData | null, propertyId: number | undefined, offerId: number | undefined): IReservationRequest | null =>
    data?.isReservationAvailable && propertyId && offerId
        ? {
              propertyId,
              offerId,
              vendorId: data.vendorId,
              propertyNumber: data.propertyNumber,
              vendorName: data.vendorName,
              offerType: data.offerType,
              placement: "unlock_choice"
          }
        : null;

const getReservationView = (
    flow: IUseReservationFlowResult,
    isConfirmed: boolean,
    onBack: () => void,
    onConfirmedClose: () => void
): IUnlockChoiceReservationView => ({
    step: isConfirmed ? "confirmed" : "code",
    codeStepProps: flow.codeStepProps,
    confirmedStepProps: flow.confirmedStepProps,
    isSubmitting: flow.isSubmitting,
    onBack,
    onConfirmedClose
});

// Handing over to the registration does not dismiss the choice, so it does not go through onClose; the user already has an account, so the login form opens
const useUnlockChoiceReservationFlow = (
    request: IReservationRequest | null,
    amplitudePlacement: AmplitudeAuthPlacement | null | undefined,
    amplitudeLocation: AmplitudeAuthLocation | undefined,
    isVisible: boolean
) => {
    const startReservationRegistration = useStartReservationRegistration();

    return useReservationFlow({
        request,
        authPlacement: amplitudePlacement,
        amplitudeLocation,
        // back on the cards the steps are hidden - showing them again reports their views anew
        isVisible,
        onUnauthenticated: (unauthenticatedRequest) =>
            startReservationRegistration(unauthenticatedRequest, SIGNED_OUT_RESERVATION_AUTH_STATE, {
                amplitudePlacement: amplitudePlacement ?? null,
                showLoginForm: true
            })
    });
};

// The free reservation of the offer choice - its steps replace the cards inside the same modal, and going back to the cards keeps the code already sent
export const useUnlockChoiceReservation = (params: IUseUnlockChoiceReservationParams) => {
    const {data, isCloseRequested, requestClose} = params;

    const {propertyId, offerId, amplitudePlacement, amplitudeLocation} = useAppSelector((state) => state.registrationFlow);
    const viewType = useAppSelector((state) => state.viewType.current);
    const [isVisible, setIsVisible] = useState(false);

    const request = getReservationRequest(data, propertyId, offerId);
    const flow = useUnlockChoiceReservationFlow(request, amplitudePlacement, amplitudeLocation, isVisible);

    const isConfirmed = isVisible && flow.state.status === "confirmed";
    const trackingContext = {authPlacement: amplitudePlacement ?? null, amplitudeLocation, viewType};
    const {close, confirmedClose} = getReservationCloseHandlers({
        request,
        isConfirmed,
        isSubmitting: flow.isSubmitting,
        isCloseRequested,
        trackingContext,
        requestClose
    });

    const start = () => {
        if (!request) {
            return;
        }

        // back from the code step the code already sent stays valid - the flow starts only once
        flow.start();
        setIsVisible(true);
    };

    const back = () => {
        if (flow.isSubmitting) {
            return;
        }

        if (request) {
            getReservationTracker(request).back(request, trackingContext);
        }

        setIsVisible(false);
    };

    return {
        isAvailable: request !== null,
        // the steps replace the cards
        isVisible,
        isConfirmed,
        view: isVisible ? getReservationView(flow, isConfirmed, back, confirmedClose) : null,
        start,
        // the close button, the overlay or Esc while the steps are shown - the reservation never leads to the price negotiation
        close,
        // call from the modal's onAfterClose
        reset: flow.reset
    };
};
